import React, {Component} from 'react';
import {getColorByState} from "../../../components/colorByState/colorByState";

class NormalStatus extends Component {
    render() {
        let {text} = this.props;
        return  <div style={{display:"flex",overflow: "hidden",textOverflow: "ellipsis",whiteSpace:"nowrap",alignItems:"center"}}>
            <div style={{width:8,height:8,backgroundColor:getColorByState(text) ,borderRadius:"50%",marginRight:"4px"}}/>
            <div>{text}</div>
        </div>
    }
}

export default NormalStatus;
